// extracted by mini-css-extract-plugin
export default {"spin":"Spinner_spin__ZVPBh","rotating":"Spinner_rotating__jwPuh"};